import { useMutation } from '@tanstack/react-query';
import { addToGroup } from './apiAddToGroup';
import { useDispatch } from 'react-redux';
import { globalErrorResponse, showNotification } from '../../../../store/notifications/actions';
import { invalidateLibraryManagedProductGroupFeaturedPages } from './useLibraryManagedProductGroupsFeaturePages';
import { useTranslation } from 'react-i18next';

export const useAddToGroup = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return useMutation(addToGroup, {
        onSuccess: (_, data) => {
            dispatch(
                showNotification(
                    t('notifications.getMessageFromActionProductGroup.add', { productTitle: data.product.title })
                )
            );
            invalidateLibraryManagedProductGroupFeaturedPages().then();
        },
        onError: () => {
            dispatch(globalErrorResponse(t('marketing.productGroups.warnings.saveProductError')));
        }
    });
};
